export enum FieldTerms {
  // Business Termer
  BT_137_LOT = 'BT-137-Lot',
  BT_21_LOT = 'BT-21-Lot',
  BT_137_PART = 'BT-137-Part',
  BT_21_PART = 'BT-21-Part',
  BT_13716_NOTICE = 'BT-13716-notice',
  BT_500_ORG_COMP = 'BT-500-Organization-Company',
  BT_500_ORG_TP = 'BT-500-Organization-TouchPoint',
  BT_04_NOTICE = 'BT-04-notice',           // Procedure ID
  BT_03_NOTICE = 'BT-03-notice',           // Form Type
  BT_02_NOTICE = 'BT-02-notice',           // Notice Type
  BT_01_NOTICE = 'BT-01-notice',           // Procedure Legal Basis
  BT_701_NOTICE = 'BT-701-notice',         // Notice Identifier
  BT_757_NOTICE = 'BT-757-notice',         // Version Identifier
  BT_758_NOTICE = 'BT-758-notice',         // Change Notice Version Identifier
  BT_702A_NOTICE = 'BT-702(a)-notice',     // Notice Official Language

  // OPT Termer
  OPT_500_ORG_COMP = 'OPT-200-Organization-Company',
  OPT_201_ORG_TP = 'OPT-201-Organization-TouchPoint',

  // OPP termer
  OPP_070_NOTICE = 'OPP-070-notice',       // Notice Dispatch Date Time
  OPP_010_NOTICE = 'OPP-010-notice',       // Notice Publication Number
}
